import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '../../common/api/createBaseQuery';
import { IAppContext } from '../../common/types/applicationContext';

export type TSubsidizedCalculatorApiEndpoits = keyof typeof subsidizedCalculatorApi.endpoints;
export let subsidizedCalculatorApi: ReturnType<typeof createSubsidizedCalculatorApi>;

export const createSubsidizedCalculatorApi = (ctx: IAppContext) => {
  const newApi = createApi({
    reducerPath: 'subsidizedCalculatorApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      endpointExample: builder.query<unknown, unknown>({
        query: parameters => ({
          parameters,
          fetchFunction: async () => ({
            response: { someValue: 'test' },
            statusCode: 200,
            headers: [],
          }),
          loggerInfo: {
            description: 'Пример запроса',
            degradation: 'Деградация запроса',
          },
        }),
      }),
    }),
  });

  subsidizedCalculatorApi = newApi;

  return newApi;
};
